/** @jsxImportSource theme-ui */
import React from 'react';

import { RiskLikelihood, RiskMagnitude } from 'models/RiskCategories';
import { valueof } from 'utils/typeHelpers';

import { ProbabilityIconMappings } from 'components/_common/BdIcon/ProbabilityIcons';
import { Typography } from 'components/_common/Typography';

type RiskDisplayTooltipProps = {
  riskLikelihood: RiskLikelihood;
  riskMagnitude: RiskMagnitude;
};

export const RiskDisplayTooltip: React.FC<RiskDisplayTooltipProps> = ({
  riskLikelihood,
  riskMagnitude,
}) => {
  const iconMapping = ProbabilityIconMappings[riskLikelihood];
  const likelihoodText =
    riskLikelihood === 'Not calculated'
      ? valueof<RiskLikelihood>('Not calculated')
      : `${iconMapping.title}: ${iconMapping.numbers}`;

  return (
    <div>
      <Typography variant="subtitle2" color="white" marginBottom="12px">
        Risk of Imporation
      </Typography>
      <Typography variant="caption" color="deepSea40" marginBottom="4px">
        Importation Likelihood
      </Typography>
      <Typography variant="subtitle2" color="white" marginBottom="8px" data-testid="likelihoodText">
        {likelihoodText}
      </Typography>
      <Typography variant="caption" color="deepSea40" marginBottom="12px">
        Overall likelihood of at least one imported infected traveller in one month
      </Typography>
      <Typography variant="caption" color="deepSea40" marginBottom="4px">
        Estimated number of imported cases/month
      </Typography>
      <Typography
        variant="subtitle2"
        color="stone10"
        marginBottom="12px"
        data-testid="riskMagnitude"
      >
        {riskMagnitude}
      </Typography>
    </div>
  );
};
